import ButtonGeneral from '@src/Components/Atoms/ButtonGeneral/ButtonGeneral';
import React, { useEffect, useState } from 'react';
import styles from './AnomalyCards.module.scss';
import { AnomalyCardsProps } from './AnomalyCards.type';
const list = [
  {
    value: 'sighting',
    title: '1',
    valueId: 1,
    subtitle: 'Sighting'
  },
  {
    value: 'encounter',
    title: '2',
    valueId: 2,
    subtitle: 'encounter'
  },
  {
    value: 'confrontation',
    title: '3',
    valueId: 3,
    subtitle: 'Confrontation'
  },
  {
    value: 'skirmish',
    title: '4',
    valueId: 4,
    subtitle: 'Skirmish'
  },
  {
    value: 'rift-incursion',
    title: '5',
    valueId: 5,
    subtitle: 'Rift incursion'
  },
  {
    value: 'mythic-outbreak',
    title: '6',
    valueId: 6,
    subtitle: 'Mythic Outbreak'
  },
  {
    value: 'mythic-invasion',
    title: '7',
    valueId: 7,
    subtitle: 'Mythic Invasion'
  }
];

const AnomalyCards: React.FC<AnomalyCardsProps> = ({
  defaultValue = [],
  onChange
}) => {
  const [checkedValue, setCheckedValue] = useState<number[]>(
    list.map((v, k) => (defaultValue[k] > -1 ? v.valueId : -1))
  );
  useEffect(() => {
    if (onChange) onChange(checkedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkedValue]);

  return (
    <div className={styles['Container']} data-testid="anomaly-cards">
      <label>Anomaly Rating</label>
      <div className={styles['Cards']}>
        {list.map((v, i) => (
          <ButtonGeneral
            key={v.value}
            title={v.title}
            subtitle={v.subtitle}
            active={checkedValue[i] > -1}
            onClick={() =>
              setCheckedValue((s) =>
                s.map((val, k) => {
                  if (k === i) {
                    return val > -1 ? -1 : k + 1;
                  }
                  return val;
                })
              )
            }
          />
        ))}
      </div>
    </div>
  );
};

export default AnomalyCards;
